import { componentStyles } from "./filter.scss";
import { useState } from "react";
import classnames from "classnames";
import { FILTER_CLICKED, FILTER_CHOICE_CLICKED } from "constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import DownArrow from "/static/svg/arrow-down.svg";
import ViSign from "/static/svg/vi_icon.svg";
import CloseIcon from "static/svg/close.svg";
import { getFilterIcon } from "components/pages/whats-new/utils";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";

const Filter = ({ title, values, data, onChange, isOpen, onToggle }) => {
  const [selectedValues, setSelectedValues] = useState(values);

  const toggleSelect = () => {
    if (!isOpen) {
      trackEvent(FILTER_CLICKED, { kind: title });
    }
    onToggle();
  };

  const updateSelectedValues = (newSelectedValues) => {
    setSelectedValues(newSelectedValues);
    if (onChange) onChange(newSelectedValues);
  };

  const handleSelect = (value) => {
    trackEvent(FILTER_CHOICE_CLICKED, { kind: title, info1: value });
    let newSelectedValues;
    if (selectedValues.includes(value)) {
      newSelectedValues = selectedValues.filter((v) => v !== value);
    } else {
      newSelectedValues = [...selectedValues, value];
    }
    updateSelectedValues(newSelectedValues);
  };

  const handleRemoveValue = (value) => {
    setSelectedValues(selectedValues.filter((v) => v !== value));
    onChange(selectedValues.filter((v) => v !== value));
  };

  const isSelected = selectedValues && selectedValues.length > 0;

  return (
    <div className={classnames("filter", { open: isOpen })}>
      <div className={classnames("filter-value", { selected: isSelected, open: isOpen })}>
        <div
          className="select-container"
          onClick={toggleSelect}
          tabIndex={0}
          onKeyDown={generateOnKeyDownHandler(() => {
            toggleSelect();
          })}
          role="button"
          aria-haspopup="listbox"
          aria-expanded={isOpen}
        >
          {selectedValues?.length > 0 ? (
            <div className="selected-values">
              <div className="filter-selected" key={selectedValues[0]}>
                {data[selectedValues[0]]?.name}
                <span
                  className="close-button"
                  onClick={() => {
                    handleRemoveValue(selectedValues[0]);
                  }}
                  tabIndex={0}
                  onKeyDown={generateOnKeyDownHandler(() => {
                    handleRemoveValue(selectedValues[0]);
                  })}
                  aria-label="Remove value"
                  role="button"
                >
                  <CloseIcon />
                </span>
              </div>
              {selectedValues.length > 1 && <div className="ellipsis">...</div>}
            </div>
          ) : (
            <div className={classnames("placeholder", { open: isOpen })}>{title}</div>
          )}
          <div className={classnames("down-arrow-wrapper", { open: isOpen })} aria-hidden={true}>
            <DownArrow className="down-arrow" />
          </div>
        </div>
        <div className="options-container">
          {Object.entries(data).map(([optionId, optionData]) => (
            <div
              className={classnames("option", {
                selected: selectedValues.includes(optionId)
              })}
              key={optionId}
              onClick={() => {
                handleSelect(optionId);
              }}
              tabIndex={0}
              onKeyDown={generateOnKeyDownHandler(() => {
                handleSelect(optionId);
              })}
              role="option"
              aria-selected={selectedValues.includes(optionId)}
            >
              <div
                className={classnames("checkbox", {
                  selected: selectedValues.includes(optionId)
                })}
              >
                <div className="v-sign">
                  <ViSign />
                </div>
              </div>
              {getFilterIcon(optionData.name)}
              {optionData.name}
            </div>
          ))}
        </div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default Filter;
